import axiosDocument from './axiosDocument';

const documentController = {
  getAllDocument(queryUrl) {
    const url = `/file/info${queryUrl}`;
    return axiosDocument.get(url);
  },
  uploadDocument(data) {
    const url = `/file`;
    const payload = data;
    return axiosDocument.post(url, payload, {});
  },
  downloadDocument(fileId) {
    const url = `/file/${fileId}/download`;
    return axiosDocument.get(url, {
      responseType: 'blob',
    });
  },
  deleteDocument(fileId) {
    const url = `/file/${fileId}`;
    return axiosDocument.delete(url, {});
  },
};

export default documentController;
